const error404 = {
    title: 'Erreur 404',
    header: '404',
    description: 'La page que vous recherchez semble introuvable',
    contactUs: 'Si le problème persiste, contactez-nous à l’adresse suivante: info@extrapole.ca',
}

export default error404
